import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  PLATFORM_ID,
  ChangeDetectionStrategy,
} from "@angular/core";
import { environment } from "../../enviroments/enviroment";

@Component({
  selector: "app-live-preview",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LivePreviewComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const win = globalThis as unknown as Window;
    if (win.parent === win) {
      return;
    }

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== environment.apiUrl) {
        return;
      }

      if (event.data?.type === "strapiUpdate") {
        globalThis.location.reload();
      } else if (event.data?.type === "strapiScript") {
        const script = document.createElement("script");
        script.textContent = event.data.payload?.script;
        document.head.appendChild(script);
      }
    };

    globalThis.addEventListener("message", messageHandler);
    this.destroyRef.onDestroy(() => {
      globalThis.removeEventListener("message", messageHandler);
    });

    win.parent.postMessage({ type: "previewReady" }, environment.apiUrl);
  }
}
